import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__left" }
const _hoisted_3 = { class: "header__center" }
const _hoisted_4 = { class: "header__right" }

import ProfileMenu from '@/components/nav/ProfileMenu.vue'
import ShareMenu from '@/components/nav/ShareMenu.vue'
import { useEndUserProfileStore } from '@/store/user-profile'
import { computed } from 'vue'
import VisualiserLogo from '@/assets/VisualiserLogo.svg'
import Badge from '@/components/nav/Badge.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderNav',
  props: {
    showForumLink: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  showForumLink: boolean
};

const endUserProfileStore = useEndUserProfileStore()



const avatarUrl = computed(() => endUserProfileStore.avatar ?? 'https://static.serato.com/common/images/default-profile-picture.svg')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(ProfileMenu, {
          class: "header__avatar",
          avatarUrl: _unref(avatarUrl),
          showForumLink: __props.showForumLink
        }, null, 8, ["avatarUrl", "showForumLink"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(ShareMenu)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(VisualiserLogo))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Badge, {
        class: "header__badge",
        text: "BETA"
      })
    ])
  ]))
}
}

})